module.exports = __webpack_public_path__ + "static/media/glutape logo.f0200bc9.jpg";